const products = {
  "Black Summer Garden Tiered Babydoll Dress - Small": 1500,
  "Black Summer Garden Tiered Babydoll Dress - Medium": 1500,
  "Black Summer Garden Tiered Babydoll Dress - Large": 1500,
  "Olive Everyday Collared Tiered Cotton Midaxi Dress - Small": 3000,
  "Olive Everyday Collared Tiered Cotton Midaxi Dress - Medium": 3000,
  "Olive Everyday Collared Tiered Cotton Midaxi Dress - Large": 3000,
  "Scarlet Floral Swing Ruffle Hem Dress - Small": 2500,
  "Scarlet Floral Swing Ruffle Hem Dress - Medium": 2500,
  "Scarlet Floral Swing Ruffle Hem Dress - Large": 2500,
  "Cherry Gingham Puff Sleeve Babydoll Dress - Small": 2000,
  "Cherry Gingham Puff Sleeve Babydoll Dress - Medium": 2000,
  "Cherry Gingham Puff Sleeve Babydoll Dress - Large": 2000,
  "Cozy Chic Ribbed Knit Mini Skirt - 24": 1800,
  "Cozy Chic Ribbed Knit Mini Skirt - 26": 1800,
  "Cozy Chic Ribbed Knit Mini Skirt - 28": 1800,
  "Boho Bloom Handmade Crochet Mini Skirt - 24": 2300,
  "Boho Bloom Handmade Crochet Mini Skirt - 26": 2300,
  "Boho Bloom Handmade Crochet Mini Skirt - 28": 2300,
  "Scarlet Twist Two-Tone Crochet Mini Skirt - 24": 2200,
  "Scarlet Twist Two-Tone Crochet Mini Skirt - 26": 2200,
  "Scarlet Twist Two-Tone Crochet Mini Skirt - 28": 2200,
  "Everyday Grace Cotton-Blend Midi Skirt - 24": 1600,
  "Everyday Grace Cotton-Blend Midi Skirt - 26": 1600,
  "Everyday Grace Cotton-Blend Midi Skirt - 28": 1600,
  "EdgeLine Utility Topstitched Mini Skirt - 24": 2000,
  "EdgeLine Utility Topstitched Mini Skirt - 26": 2000,
  "EdgeLine Utility Topstitched Mini Skirt - 28": 2000,
  "Soft Flow Rayon Midi Skirt - 24": 1900,
  "Soft Flow Rayon Midi Skirt - 26": 1900,
  "Soft Flow Rayon Midi Skirt - 28": 1900,
  "Elysian Drape Crepe Maxi Skirt - 24": 2500,
  "Elysian Drape Crepe Maxi Skirt - 26": 2500,
  "Elysian Drape Crepe Maxi Skirt - 28": 2500,
  "EarthWeave Cotton-Jute Long Skirt - 24": 2300,
  "EarthWeave Cotton-Jute Long Skirt - 26": 2300,
  "EarthWeave Cotton-Jute Long Skirt - 28": 2300,
  "Luminous Pearl White Bead-Embellished Skirt - 24": 3000,
  "Luminous Pearl White Bead-Embellished Skirt - 26": 3000,
  "Luminous Pearl White Bead-Embellished Skirt - 28": 3000,
  "BloomFlex Floral Print Stretch Midi Skirt - 24": 1600,
  "BloomFlex Floral Print Stretch Midi Skirt - 26": 1600,
  "BloomFlex Floral Print Stretch Midi Skirt - 28": 1600,
  "MetroStitch Dual Pocket Mini Skirt - 24": 2000,
  "MetroStitch Dual Pocket Mini Skirt - 26": 2000,
  "MetroStitch Dual Pocket Mini Skirt - 28": 2000,
  "FrostFlow Ice Blue Wide-Leg Denim Jeans - 24": 1800,
  "FrostFlow Ice Blue Wide-Leg Denim Jeans - 26": 1800,
  "FrostFlow Ice Blue Wide-Leg Denim Jeans - 28": 1800,
  "Midnight Frame Wide-Leg Black Denim Jeans - 24": 1900,
  "Midnight Frame Wide-Leg Black Denim Jeans - 26": 1900,
  "Midnight Frame Wide-Leg Black Denim Jeans - 28": 1900,
  "SkyEase High-Rise Relaxed Fit Blue Jeans - 24": 2000,
  "SkyEase High-Rise Relaxed Fit Blue Jeans - 26": 2000,
  "SkyEase High-Rise Relaxed Fit Blue Jeans - 28": 2000,
  "CurveSet Loose Bowed Denim Jeans - 24": 1800,
  "CurveSet Loose Bowed Denim Jeans - 26": 1800,
  "CurveSet Loose Bowed Denim Jeans - 28": 1800,
  "TrueTone Classic Blue Denim Jeans - 24": 2100,
  "TrueTone Classic Blue Denim Jeans - 26": 2100,
  "TrueTone Classic Blue Denim Jeans - 28": 2100,
  "StreetEase Baggy Fit Denim Jeans - 24": 2400,
  "StreetEase Baggy Fit Denim Jeans - 26": 2400,
  "StreetEase Baggy Fit Denim Jeans - 28": 2400,
  "SculptFit 5-Pocket Skinny Denim Jeans - 24": 1700,
  "SculptFit 5-Pocket Skinny Denim Jeans - 26": 1700,
  "SculptFit 5-Pocket Skinny Denim Jeans - 28": 1700,
  "DustFade Boyfriend-Fit Dirt Wash Jeans - 24": 2800,
  "DustFade Boyfriend-Fit Dirt Wash Jeans - 26": 2800,
  "DustFade Boyfriend-Fit Dirt Wash Jeans - 28": 2800,
  "Glacier Edge Straight Fit Denim – Ice Blue Classic - 24": 2200,
  "Glacier Edge Straight Fit Denim – Ice Blue Classic - 26": 2200,
  "Glacier Edge Straight Fit Denim – Ice Blue Classic - 28": 2200,
  "Breezelite Chambray Shorts – Effortless Summer Style - 24": 1400,
  "Breezelite Chambray Shorts – Effortless Summer Style - 26": 1400,
  "Breezelite Chambray Shorts – Effortless Summer Style - 28": 1400,
  "CloudEase Relaxed Cotton Shorts – Ultimate Comfort Wear - 24": 1800,
  "CloudEase Relaxed Cotton Shorts – Ultimate Comfort Wear - 26": 1800,
  "CloudEase Relaxed Cotton Shorts – Ultimate Comfort Wear - 28": 1800,
  "Azure Breeze Printed Linen Shorts – Light & Stylish - 24": 1600,
  "Azure Breeze Printed Linen Shorts – Light & Stylish - 26": 1600,
  "Azure Breeze Printed Linen Shorts – Light & Stylish - 28": 1600,
  "Urban Chic Cotton-Blend Mini Shorts – Playful & Comfortable - 24": 1300,
  "Urban Chic Cotton-Blend Mini Shorts – Playful & Comfortable - 26": 1300,
  "Urban Chic Cotton-Blend Mini Shorts – Playful & Comfortable - 28": 1300,
  "Sophisticate Contrast Band Tweed Shorts – Timeless Elegance - 24": 2100,
  "Sophisticate Contrast Band Tweed Shorts – Timeless Elegance - 26": 2100,
  "Sophisticate Contrast Band Tweed Shorts – Timeless Elegance - 28": 2100,
  "Vibrance Majolica-Print Shorts – Colorful Summer Statement - 24": 2500,
  "Vibrance Majolica-Print Shorts – Colorful Summer Statement - 26": 2500,
  "Vibrance Majolica-Print Shorts – Colorful Summer Statement - 28": 2500,
  "Seaside Stripes Cotton Shorts – Classic Comfort & Style - 24": 1200,
  "Seaside Stripes Cotton Shorts – Classic Comfort & Style - 26": 1200,
  "Seaside Stripes Cotton Shorts – Classic Comfort & Style - 28": 1200,
  "EasyStride Relaxed Fit Shorts – Comfort Meets Casual - 24": 1800,
  "EasyStride Relaxed Fit Shorts – Comfort Meets Casual - 26": 1800,
  "EasyStride Relaxed Fit Shorts – Comfort Meets Casual - 28": 1800,
  "Boho Breeze Crochet Tie Cotton-Blend Shorts – Effortless Charm - 24": 2700,
  "Boho Breeze Crochet Tie Cotton-Blend Shorts – Effortless Charm - 26": 2700,
  "Boho Breeze Crochet Tie Cotton-Blend Shorts – Effortless Charm - 28": 2700,
  "Elegance Embrace High-Waisted Lace Shorts – Feminine & Refined - 24": 3000,
  "Elegance Embrace High-Waisted Lace Shorts – Feminine & Refined - 26": 3000,
  "Elegance Embrace High-Waisted Lace Shorts – Feminine & Refined - 28": 3000,
  "Sand Cream Stripe Waist-Tie Midi Dress - Small": 3500,
  "Sand Cream Stripe Waist-Tie Midi Dress - Medium": 3500,
  "Sand Cream Stripe Waist-Tie Midi Dress - Large": 3500,
  "Off-Shoulder Leopard Print Maxi Dress - Small": 3500,
  "Off-Shoulder Leopard Print Maxi Dress - Medium": 3500,
  "Off-Shoulder Leopard Print Maxi Dress - Large": 3500,
  "Cocoa Button-Front Collared Tiered Midi Dress - Small": 4000,
  "Cocoa Button-Front Collared Tiered Midi Dress - Medium": 4000,
  "Cocoa Button-Front Collared Tiered Midi Dress - Large": 4000,
  "Black Knit Stripe-Panel Skater Dress - Small": 2800,
  "Black Knit Stripe-Panel Skater Dress - Medium": 2800,
  "Black Knit Stripe-Panel Skater Dress - Large": 2800,
  "Olive Blush Botanical Smocked Midi Dress - Small": 3000,
  "Olive Blush Botanical Smocked Midi Dress - Medium": 3000,
  "Olive Blush Botanical Smocked Midi Dress - Large": 3000,
  "Black Satin Pleated Floral Midi Shirt Dress - Small": 3000,
  "Black Satin Pleated Floral Midi Shirt Dress - Medium": 3000,
  "Black Satin Pleated Floral Midi Shirt Dress - Large": 3000,
  "White Broderie Tiered Button-Front Shift Dress - Small": 5000,
  "White Broderie Tiered Button-Front Shift Dress - Medium": 5000,
  "White Broderie Tiered Button-Front Shift Dress - Large": 5000,
  "Olive Ikat Bell Sleeve Tiered Midi Dress - Small": 4000,
  "Olive Ikat Bell Sleeve Tiered Midi Dress - Medium": 4000,
  "Olive Ikat Bell Sleeve Tiered Midi Dress - Large": 4000,
  "Lemon Zest Sleeveless Drop-Waist Mini Dress - Small": 3500,
  "Lemon Zest Sleeveless Drop-Waist Mini Dress - Medium": 3500,
  "Lemon Zest Sleeveless Drop-Waist Mini Dress - Large": 3500,
  "Midnight Classic Drawstring Shirt Midi Dress - Small": 3500,
  "Midnight Classic Drawstring Shirt Midi Dress - Medium": 3500,
  "Midnight Classic Drawstring Shirt Midi Dress - Large": 3500,
  "Maroon Paisley Mosaic Flare Sleeve Tunic Dress - Small": 3000,
  "Maroon Paisley Mosaic Flare Sleeve Tunic Dress - Medium": 3000,
  "Maroon Paisley Mosaic Flare Sleeve Tunic Dress - Large": 3000,
  "Dusty Rose Relaxed V-Neck Pocket Midi Dress - Small": 3500,
  "Dusty Rose Relaxed V-Neck Pocket Midi Dress - Medium": 3500,
  "Dusty Rose Relaxed V-Neck Pocket Midi Dress - Large": 3500,
  "ropical Off-Shoulder Tiered Sundress - Small": 3500,
  "ropical Off-Shoulder Tiered Sundress - Medium": 3500,
  "ropical Off-Shoulder Tiered Sundress - Large": 3500,
  "Olive Blossom Pleated Babydoll Tie-Back Dress - Small": 2000,
  "Olive Blossom Pleated Babydoll Tie-Back Dress - Medium": 2000,
  "Olive Blossom Pleated Babydoll Tie-Back Dress - Large": 2000,
  "Midnight Pearl Button Knit Midi Dress - Small": 4000,
  "Midnight Pearl Button Knit Midi Dress - Medium": 4000,
  "Midnight Pearl Button Knit Midi Dress - Large": 4000,
  "Mocha Botanical Tie-Belt Pleated Mini Dress - Small": 3000,
  "Mocha Botanical Tie-Belt Pleated Mini Dress - Medium": 3000,
  "Mocha Botanical Tie-Belt Pleated Mini Dress - Large": 3000,
  "Noir Button-Down Tie-Waist Midi Shirt Dress - Small": 3200,
  "Noir Button-Down Tie-Waist Midi Shirt Dress - Medium": 3200,
  "Noir Button-Down Tie-Waist Midi Shirt Dress - Large": 3200,
  "Olive Cap Sleeve Sleek Pencil Dress - Small": "0004000",
  "Olive Cap Sleeve Sleek Pencil Dress - Medium": "0004000",
  "Olive Cap Sleeve Sleek Pencil Dress - Large": "0004000",
  "Watercolor Garden Backless Halter Mini Dress - Small": 4500,
  "Watercolor Garden Backless Halter Mini Dress - Medium": 4500,
  "Watercolor Garden Backless Halter Mini Dress - Large": 4500,
  "Cocoa Blossom Sheer Flutter Sleeve Midi Dress - Small": 3500,
  "Cocoa Blossom Sheer Flutter Sleeve Midi Dress - Medium": 3500,
  "Cocoa Blossom Sheer Flutter Sleeve Midi Dress - Large": 3500,
  "Moss Tiered T-Shirt Maxi Dress - Small": 4000,
  "Moss Tiered T-Shirt Maxi Dress - Medium": 4000,
  "Moss Tiered T-Shirt Maxi Dress - Large": 4000,
  "Azure Leaf Flutter Sleeve Tiered Mini Dress - Small": 2200,
  "Azure Leaf Flutter Sleeve Tiered Mini Dress - Medium": 2200,
  "Azure Leaf Flutter Sleeve Tiered Mini Dress - Large": 2200,
  "Tangerine Blossom Flare Hem Mini Dress - Small": 2500,
  "Tangerine Blossom Flare Hem Mini Dress - Medium": 2500,
  "Tangerine Blossom Flare Hem Mini Dress - Large": 2500,
  "Olive Flounce Drop-Waist Sleeveless Mini Dress - Small": 2500,
  "Olive Flounce Drop-Waist Sleeveless Mini Dress - Medium": 2500,
  "Olive Flounce Drop-Waist Sleeveless Mini Dress - Large": 2500,
  "Mocha Ruffle-Sleeve Relaxed Babydoll Dress - Small": 3000,
  "Mocha Ruffle-Sleeve Relaxed Babydoll Dress - Medium": 3000,
  "Mocha Ruffle-Sleeve Relaxed Babydoll Dress - Large": 3000,
  "Olive Bamboo Print Button-Front Tie-Waist Midi Dress - Small": 2500,
  "Olive Bamboo Print Button-Front Tie-Waist Midi Dress - Medium": 2500,
  "Olive Bamboo Print Button-Front Tie-Waist Midi Dress - Large": 2500,
  "Peach Ribbed Drop-Shoulder Knit Top - Small": 2000,
  "Peach Ribbed Drop-Shoulder Knit Top - Medium": 2000,
  "Peach Ribbed Drop-Shoulder Knit Top - Large": 2000,
  "Chestnut Puff Sleeve Peplum Lace Trim Top - Small": 2000,
  "Chestnut Puff Sleeve Peplum Lace Trim Top - Medium": 2000,
  "Chestnut Puff Sleeve Peplum Lace Trim Top - Large": 2000,
  "Vermilion Relaxed Drop-Shoulder Shirt Top - Small": 1500,
  "Vermilion Relaxed Drop-Shoulder Shirt Top - Medium": 1500,
  "Vermilion Relaxed Drop-Shoulder Shirt Top - Large": 1500,
  "Buttercup Ruched Waist Puff Sleeve Peplum Top - Small": 2500,
  "Buttercup Ruched Waist Puff Sleeve Peplum Top - Medium": 2500,
  "Buttercup Ruched Waist Puff Sleeve Peplum Top - Large": 2500,
  "Apricot Puff Sleeve Eyelet Peplum Top with Tie-Back - Small": 2500,
  "Apricot Puff Sleeve Eyelet Peplum Top with Tie-Back - Medium": 2500,
  "Apricot Puff Sleeve Eyelet Peplum Top with Tie-Back - Large": 2500,
  "Black Leaf Print Relaxed Short Sleeve Top - Small": 1500,
  "Black Leaf Print Relaxed Short Sleeve Top - Medium": 1500,
  "Black Leaf Print Relaxed Short Sleeve Top - Large": 1500,
  "Steel Blue Pocket Crew Tee - Small": 1500,
  "Steel Blue Pocket Crew Tee - Medium": 1500,
  "Steel Blue Pocket Crew Tee - Large": 1500,
  "Off-Shoulder Stripe Ribbed Knit Top - Small": 1800,
  "Off-Shoulder Stripe Ribbed Knit Top - Medium": 1800,
  "Off-Shoulder Stripe Ribbed Knit Top - Large": 1800,
  "Monochrome Wave Stripe Boxy Knit Top - Small": 2000,
  "Monochrome Wave Stripe Boxy Knit Top - Medium": 2000,
  "Monochrome Wave Stripe Boxy Knit Top - Large": 2000,
  "Olive Linen-Blend Button-Front Waistcoat Top - Small": 3000,
  "Olive Linen-Blend Button-Front Waistcoat Top - Medium": 3000,
  "Olive Linen-Blend Button-Front Waistcoat Top - Large": 3000,
  "Mulberry Paisley Wrap Tie Peplum Top - Small": 2000,
  "Mulberry Paisley Wrap Tie Peplum Top - Medium": 2000,
  "Mulberry Paisley Wrap Tie Peplum Top - Large": 2000,
  "Pleated Watercolor Abstract Print Top - Small": 2000,
  "Pleated Watercolor Abstract Print Top - Medium": 2000,
  "Pleated Watercolor Abstract Print Top - Large": 2000,
  "Khaki Gathered Tie-Neck Cotton Top - Small": 1500,
  "Khaki Gathered Tie-Neck Cotton Top - Medium": 1500,
  "Khaki Gathered Tie-Neck Cotton Top - Large": 1500,
  "Mauve Foil Leaf Print Relaxed Blouse (T-Shirt Style) - Small": 1600,
  "Mauve Foil Leaf Print Relaxed Blouse (T-Shirt Style) - Medium": 1600,
  "Mauve Foil Leaf Print Relaxed Blouse (T-Shirt Style) - Large": 1600,
  "Indigo Ruffle-Front Denim Top - Small": 2500,
  "Indigo Ruffle-Front Denim Top - Medium": 2500,
  "Indigo Ruffle-Front Denim Top - Large": 2500,
  "Leopard-Print Ruched Front Long Sleeve Top - Small": 2000,
  "Leopard-Print Ruched Front Long Sleeve Top - Medium": 2000,
  "Leopard-Print Ruched Front Long Sleeve Top - Large": 2000,
  "Olive Ribbed Button-Front Polo Top - Small": 1700,
  "Olive Ribbed Button-Front Polo Top - Medium": 1700,
  "Olive Ribbed Button-Front Polo Top - Large": 1700,
  "Rose Cloud Tie-Dye Empire Peplum Top - Small": 1500,
  "Rose Cloud Tie-Dye Empire Peplum Top - Medium": 1500,
  "Rose Cloud Tie-Dye Empire Peplum Top - Large": 1500,
  "Sunlily Embroidered Sleeveless Top – White & Effortlessly Chic - Small": 1000,
  "Sunlily Embroidered Sleeveless Top – White & Effortlessly Chic - Medium": 1000,
  "Sunlily Embroidered Sleeveless Top – White & Effortlessly Chic - Large": 1000,
  "Black Relaxed Popover Tunic Top - Small": 1000,
  "Black Relaxed Popover Tunic Top - Medium": 1000,
  "Black Relaxed Popover Tunic Top - Large": 1000,
  "Black Multi Floral Long Sleeve Knit Top - Small": 1000,
  "Black Multi Floral Long Sleeve Knit Top - Medium": 1000,
  "Black Multi Floral Long Sleeve Knit Top - Large": 1000,
  "BoldMuse Blue Slogan Tee – Speak Your Style - Small": 500,
  "BoldMuse Blue Slogan Tee – Speak Your Style - Medium": 500,
  "BoldMuse Blue Slogan Tee – Speak Your Style - Large": 500,
  "Indigo Puff Sleeve Denim Shirt Top - Small": 2000,
  "Indigo Puff Sleeve Denim Shirt Top - Medium": 2000,
  "Indigo Puff Sleeve Denim Shirt Top - Large": 2000,
  "Pistachio Swiss Dot Peplum Long Sleeve Top - Small": 2000,
  "Pistachio Swiss Dot Peplum Long Sleeve Top - Medium": 2000,
  "Pistachio Swiss Dot Peplum Long Sleeve Top - Large": 2000,
  "Citrus Glow High-Waist Trousers – Bold, Bright & Tailored - 24": 1200,
  "Citrus Glow High-Waist Trousers – Bold, Bright & Tailored - 26": 1200,
  "Citrus Glow High-Waist Trousers – Bold, Bright & Tailored - 28": 1200,
  "White Scoop Neck Long Sleeve Fitted Tee - Small": 1500,
  "White Scoop Neck Long Sleeve Fitted Tee - Medium": 1500,
  "White Scoop Neck Long Sleeve Fitted Tee - Large": 1500,
  "Dusty Rose Ribbed Dolman Sweater Top - Small": 2000,
  "Dusty Rose Ribbed Dolman Sweater Top - Medium": 2000,
  "Dusty Rose Ribbed Dolman Sweater Top - Large": 2000,
  "PowerStride Red Side-Band Trousers – Sporty Meets Chic - 24": 1100,
  "PowerStride Red Side-Band Trousers – Sporty Meets Chic - 26": 1100,
  "PowerStride Red Side-Band Trousers – Sporty Meets Chic - 28": 1100,
  "Black Crochet Trim Balloon Sleeve Cropped Top - Small": 1500,
  "Black Crochet Trim Balloon Sleeve Cropped Top - Medium": 1500,
  "Black Crochet Trim Balloon Sleeve Cropped Top - Large": 1500,
  "Midnight Flow Wide-Leg Trousers – Effortless Elegance in Black - 24": 1300,
  "Midnight Flow Wide-Leg Trousers – Effortless Elegance in Black - 26": 1300,
  "Midnight Flow Wide-Leg Trousers – Effortless Elegance in Black - 28": 1300,
  "Crimson Poise Plain Trousers – Bordeaux Elegance, Everyday Ease - 24": 1400,
  "Crimson Poise Plain Trousers – Bordeaux Elegance, Everyday Ease - 26": 1400,
  "Crimson Poise Plain Trousers – Bordeaux Elegance, Everyday Ease - 28": 1400,
  "Orchid Textured Split-Neck Long Sleeve Top - Small": 2000,
  "Orchid Textured Split-Neck Long Sleeve Top - Medium": 2000,
  "Orchid Textured Split-Neck Long Sleeve Top - Large": 2000,
  "Periwinkle Square Neck Long Sleeve Top - Small": 1200,
  "Periwinkle Square Neck Long Sleeve Top - Medium": 1200,
  "Periwinkle Square Neck Long Sleeve Top - Large": 1200,
  "Black Ruffle Trim Tie-Front Peasant Top - Small": 1500,
  "Black Ruffle Trim Tie-Front Peasant Top - Medium": 1500,
  "Black Ruffle Trim Tie-Front Peasant Top - Large": 1500,
  "Olive Drape Wide-Leg Trousers – Effortless Grace in Green - 24": 1400,
  "Olive Drape Wide-Leg Trousers – Effortless Grace in Green - 26": 1400,
  "Olive Drape Wide-Leg Trousers – Effortless Grace in Green - 28": 1400,
  "Sandstone Canvas Balloon Trousers – Relaxed Structure, Redefined - 24": 1600,
  "Sandstone Canvas Balloon Trousers – Relaxed Structure, Redefined - 26": 1600,
  "Sandstone Canvas Balloon Trousers – Relaxed Structure, Redefined - 28": 1600,
  "WineMist Short Wide-Leg Trousers – Bold Comfort in Bordeaux - 24": 1300,
  "WineMist Short Wide-Leg Trousers – Bold Comfort in Bordeaux - 26": 1300,
  "WineMist Short Wide-Leg Trousers – Bold Comfort in Bordeaux - 28": 1300,
  "Ivory Sky High-Rise Wide-Leg Trousers – Pure Elegance in Motion - 24": 1800,
  "Ivory Sky High-Rise Wide-Leg Trousers – Pure Elegance in Motion - 26": 1800,
  "Ivory Sky High-Rise Wide-Leg Trousers – Pure Elegance in Motion - 28": 1800,
  "Leafline Ankle-Length Trousers – Fresh Style, Tailored Fit - 24": 1500,
  "Leafline Ankle-Length Trousers – Fresh Style, Tailored Fit - 26": 1500,
  "Leafline Ankle-Length Trousers – Fresh Style, Tailored Fit - 28": 1500,
  "Midnight Edge Ankle-Length Trousers – Classic Navy, Modern Cut - 24": 1500,
  "Midnight Edge Ankle-Length Trousers – Classic Navy, Modern Cut - 26": 1500,
  "Midnight Edge Ankle-Length Trousers – Classic Navy, Modern Cut - 28": 1500,
  "Verdant Pace Jogging Trousers – Comfort in Motion - 24": 1700,
  "Verdant Pace Jogging Trousers – Comfort in Motion - 26": 1700,
  "Verdant Pace Jogging Trousers – Comfort in Motion - 28": 1700,
  "ShadowLine Wide-Leg Trousers – Effortless Black Elegance - 24": 1400,
  "ShadowLine Wide-Leg Trousers – Effortless Black Elegance - 26": 1400,
  "ShadowLine Wide-Leg Trousers – Effortless Black Elegance - 28": 1400,
  "Black Smocked Ruffle-Hem Peasant Top - Small": 1500,
  "Black Smocked Ruffle-Hem Peasant Top - Medium": 1500,
  "Black Smocked Ruffle-Hem Peasant Top - Large": 1500,
  "White Bubble Hem Babydoll Camisole Top - Small": 2000,
  "White Bubble Hem Babydoll Camisole Top - Medium": 2000,
  "White Bubble Hem Babydoll Camisole Top - Large": 2000,
  "PureCanvas Printed Tee – Bold Statements on White - Small": 700,
  "PureCanvas Printed Tee – Bold Statements on White - Medium": 700,
  "PureCanvas Printed Tee – Bold Statements on White - Large": 700,
  "Black and White Stripe Cotton Crewneck T-Shirt - Small": 2000,
  "Black and White Stripe Cotton Crewneck T-Shirt - Medium": 2000,
  "Black and White Stripe Cotton Crewneck T-Shirt - Large": 2000,
  "Azure Wave Striped Polo – Classic Blue Stripe Cool - Small": 900,
  "Azure Wave Striped Polo – Classic Blue Stripe Cool - Medium": 900,
  "Azure Wave Striped Polo – Classic Blue Stripe Cool - Large": 900,
  "Red Cherry Graphic Cropped T-Shirt - Small": 400,
  "Red Cherry Graphic Cropped T-Shirt - Medium": 400,
  "Red Cherry Graphic Cropped T-Shirt - Large": 400,
  "Fierce Spirit Leopard Slogan Tee – Bold & Unapologetic - Small": 800,
  "Fierce Spirit Leopard Slogan Tee – Bold & Unapologetic - Medium": 800,
  "Fierce Spirit Leopard Slogan Tee – Bold & Unapologetic - Large": 800,
  "Dream Inspire Create Slogan T-Shirt - Small": 1000,
  "Dream Inspire Create Slogan T-Shirt - Medium": 1000,
  "Dream Inspire Create Slogan T-Shirt - Large": 1000,
  "White Abstract Line Art Graphic T-Shirt - Small": 500,
  "White Abstract Line Art Graphic T-Shirt - Medium": 500,
  "White Abstract Line Art Graphic T-Shirt - Large": 500,
  "Artisan Threadwork Embroidered Cotton Tee - Small": 1200,
  "Artisan Threadwork Embroidered Cotton Tee - Medium": 1200,
  "Artisan Threadwork Embroidered Cotton Tee - Large": 1200,
  "Olive Green Essential Crewneck T-Shirt - Small": 1000,
  "Olive Green Essential Crewneck T-Shirt - Medium": 1000,
  "Olive Green Essential Crewneck T-Shirt - Large": 1000,
  "Verdant Elegance Green Embroidered Cotton Tee - Small": 1200,
  "Verdant Elegance Green Embroidered Cotton Tee - Medium": 1200,
  "Verdant Elegance Green Embroidered Cotton Tee - Large": 1200,
  "Rust and Cream Stripe Rib Knit T-Shirt - Small": "0800",
  "Rust and Cream Stripe Rib Knit T-Shirt - Medium": "0800",
  "Rust and Cream Stripe Rib Knit T-Shirt - Large": "0800",
  "Elegant Whisper Cream Lace-Effect Blouse - Small": 1400,
  "Elegant Whisper Cream Lace-Effect Blouse - Medium": 1400,
  "Elegant Whisper Cream Lace-Effect Blouse - Large": 1400,
  "Classic Black Fitted Rib Crewneck T-Shirt - Small": 600,
  "Classic Black Fitted Rib Crewneck T-Shirt - Medium": 600,
  "Classic Black Fitted Rib Crewneck T-Shirt - Large": 600,
  "Bold Statement Green Print Slogan Tee - Small": 800,
  "Bold Statement Green Print Slogan Tee - Medium": 800,
  "Bold Statement Green Print Slogan Tee - Large": 800,
  "White Graphic Portrait Bow Detail T-Shirt - Small": 1300,
  "White Graphic Portrait Bow Detail T-Shirt - Medium": 1300,
  "White Graphic Portrait Bow Detail T-Shirt - Large": 1300,
  "Retro Martini Glass Graphic Oversized T-Shirt - Small": 1100,
  "Retro Martini Glass Graphic Oversized T-Shirt - Medium": 1100,
  "Retro Martini Glass Graphic Oversized T-Shirt - Large": 1100,
  "Kindness Floral Graphic Cream T-Shirt - Small": 600,
  "Kindness Floral Graphic Cream T-Shirt - Medium": 600,
  "Kindness Floral Graphic Cream T-Shirt - Large": 600,
  "White Classic Button-Down Cotton Shirt - Small": 2000,
  "White Classic Button-Down Cotton Shirt - Medium": 2000,
  "White Classic Button-Down Cotton Shirt - Large": 2000,
  "Navy Blue Stretch Cotton Button-Down Shirt - Small": 1900,
  "Navy Blue Stretch Cotton Button-Down Shirt - Medium": 1900,
  "Navy Blue Stretch Cotton Button-Down Shirt - Large": 1900,
  "Cream & Rust Floral Print Twist-Front Shirt - Small": 1200,
  "Cream & Rust Floral Print Twist-Front Shirt - Medium": 1200,
  "Cream & Rust Floral Print Twist-Front Shirt - Large": 1200,
  "Blue Pinstripe Tailored Button-Down Shirt - Small": 1800,
  "Blue Pinstripe Tailored Button-Down Shirt - Medium": 1800,
  "Blue Pinstripe Tailored Button-Down Shirt - Large": 1800,
  "Pure Ease White Cotton Co-Ord Set for Women - Small": 1800,
  "Pure Ease White Cotton Co-Ord Set for Women - Medium": 1800,
  "Pure Ease White Cotton Co-Ord Set for Women - Large": 1800,
  "Denim Cropped Shirt with Utility Pockets - Small": 2000,
  "Denim Cropped Shirt with Utility Pockets - Medium": 2000,
  "Denim Cropped Shirt with Utility Pockets - Large": 2000,
  "Breezy Bloom Sky Blue Printed Linen-Cotton Co-Ord Set - Small": 2400,
  "Breezy Bloom Sky Blue Printed Linen-Cotton Co-Ord Set - Medium": 2400,
  "Breezy Bloom Sky Blue Printed Linen-Cotton Co-Ord Set - Large": 2400,
  "Beige Cropped Utility Shirt - Small": 1400,
  "Beige Cropped Utility Shirt - Medium": 1400,
  "Beige Cropped Utility Shirt - Large": 1400,
  "Midnight Muse Black Linen Co-Ord Set - Small": 3000,
  "Midnight Muse Black Linen Co-Ord Set - Medium": 3000,
  "Midnight Muse Black Linen Co-Ord Set - Large": 3000,
  "Title: White Classic Relaxed Button-Down Shirt - Small": 1400,
  "Title: White Classic Relaxed Button-Down Shirt - Medium": 1400,
  "Title: White Classic Relaxed Button-Down Shirt - Large": 1400,
  "Earth Tone Luxe Dark Brown Plated Co-Ord Set - Small": 3500,
  "Earth Tone Luxe Dark Brown Plated Co-Ord Set - Medium": 3500,
  "Earth Tone Luxe Dark Brown Plated Co-Ord Set - Large": 3500,
  "Ocean Drift Teal Blue Printed Co-Ord Set - Small": 4000,
  "Ocean Drift Teal Blue Printed Co-Ord Set - Medium": 4000,
  "Ocean Drift Teal Blue Printed Co-Ord Set - Large": 4000,
  "Modern Muse White Striped Co-Ord Set with Chic Collar - Small": 3000,
  "Modern Muse White Striped Co-Ord Set with Chic Collar - Medium": 3000,
  "Modern Muse White Striped Co-Ord Set with Chic Collar - Large": 3000,
  "Noir Bloom Black Printed Linen Co-Ord Set - Small": 3400,
  "Noir Bloom Black Printed Linen Co-Ord Set - Medium": 3400,
  "Noir Bloom Black Printed Linen Co-Ord Set - Large": 3400,
  "Viva Luxe Multicolour Satin Printed Co-Ord Set - Small": 2800,
  "Viva Luxe Multicolour Satin Printed Co-Ord Set - Medium": 2800,
  "Viva Luxe Multicolour Satin Printed Co-Ord Set - Large": 2800,
  "Sunset Stride Red & Purple Striped Co-Ord Set - Small": 3000,
  "Sunset Stride Red & Purple Striped Co-Ord Set - Medium": 3000,
  "Sunset Stride Red & Purple Striped Co-Ord Set - Large": 3000,
  "Midnight Jade Black & Green Satin Co-Ord Set - Small": 2300,
  "Midnight Jade Black & Green Satin Co-Ord Set - Medium": 2300,
  "Midnight Jade Black & Green Satin Co-Ord Set - Large": 2300,
  "Black Floral Print Button-Up Long Sleeve Shirt for Women - Small": 2000,
  "Black Floral Print Button-Up Long Sleeve Shirt for Women - Medium": 2000,
  "Black Floral Print Button-Up Long Sleeve Shirt for Women - Large": 2000,
  "SculptFlex High-Rise Stretch Compressive Jeggings - 24": 1200,
  "SculptFlex High-Rise Stretch Compressive Jeggings - 26": 1200,
  "SculptFlex High-Rise Stretch Compressive Jeggings - 28": 1200,
  "Mediterranea Muse Majolica-Print Jeggings - 24": 1600,
  "Mediterranea Muse Majolica-Print Jeggings - 26": 1600,
  "Mediterranea Muse Majolica-Print Jeggings - 28": 1600,
  "VelvaLuxe Stretch Velvet Jeggings - 24": 1400,
  "VelvaLuxe Stretch Velvet Jeggings - 26": 1400,
  "VelvaLuxe Stretch Velvet Jeggings - 28": 1400,
  "TrueFit Classic Blue High-Stretch Jeggings - 24": 1500,
  "TrueFit Classic Blue High-Stretch Jeggings - 26": 1500,
  "TrueFit Classic Blue High-Stretch Jeggings - 28": 1500,
  "Skyline Sculpt Mid-Wash Blue Jeggings - 24": 1600,
  "Skyline Sculpt Mid-Wash Blue Jeggings - 26": 1600,
  "Skyline Sculpt Mid-Wash Blue Jeggings - 28": 1600,
  "Urban Edge Blue Jeggings with Bold Yellow Stripe - 24": 1500,
  "Urban Edge Blue Jeggings with Bold Yellow Stripe - 26": 1500,
  "Urban Edge Blue Jeggings with Bold Yellow Stripe - 28": 1500,
  "PowerPulse Red Nylon Jeggings with Blue Side Stripes - 24": 1400,
  "PowerPulse Red Nylon Jeggings with Blue Side Stripes - 26": 1400,
  "PowerPulse Red Nylon Jeggings with Blue Side Stripes - 28": 1400,
  "BlushFit High-Rise Stretch Pink Jeggings - 24": 1200,
  "BlushFit High-Rise Stretch Pink Jeggings - 26": 1200,
  "BlushFit High-Rise Stretch Pink Jeggings - 28": 1200,
  "CocoaCurve Brown Nylon Sculpt Jeggings - 24": 1300,
  "CocoaCurve Brown Nylon Sculpt Jeggings - 26": 1300,
  "CocoaCurve Brown Nylon Sculpt Jeggings - 28": 1300,
  "TerrainFlex Olive Green Nylon Performance Jeggings - 24": 1200,
  "TerrainFlex Olive Green Nylon Performance Jeggings - 26": 1200,
  "TerrainFlex Olive Green Nylon Performance Jeggings - 28": 1200,
  "RoseGlow Soft Stretch Pink Jeggings - 24": 1300,
  "RoseGlow Soft Stretch Pink Jeggings - 26": 1300,
  "RoseGlow Soft Stretch Pink Jeggings - 28": 1300,
  "EarthEcho Brown Printed Sculpt Jeggings - 24": 1600,
  "EarthEcho Brown Printed Sculpt Jeggings - 26": 1600,
  "EarthEcho Brown Printed Sculpt Jeggings - 28": 1600,
  "Light Blue Cropped Button-Up Shirt with Maroon Side-Stripe Relaxed Trousers - Small": 1800,
  "Light Blue Cropped Button-Up Shirt with Maroon Side-Stripe Relaxed Trousers - Medium": 1800,
  "Light Blue Cropped Button-Up Shirt with Maroon Side-Stripe Relaxed Trousers - Large": 1800,
  "Teal Green Relaxed Fit Button-Up Shirt for Women - Small": 2500,
  "Teal Green Relaxed Fit Button-Up Shirt for Women - Medium": 2500,
  "Teal Green Relaxed Fit Button-Up Shirt for Women - Large": 2500,
  "Sage Green Embellished Button-Up Shirt for Women - Small": 2500,
  "Sage Green Embellished Button-Up Shirt for Women - Medium": 2500,
  "Sage Green Embellished Button-Up Shirt for Women - Large": 2500,
  "Olive Tie-Dye Floral Button-Up Shirt for Women - Small": 2500,
  "Olive Tie-Dye Floral Button-Up Shirt for Women - Medium": 2500,
  "Olive Tie-Dye Floral Button-Up Shirt for Women - Large": 2500,
  "Black Cutwork Button-Up Shirt for Women - Small": 2400,
  "Black Cutwork Button-Up Shirt for Women - Medium": 2400,
  "Black Cutwork Button-Up Shirt for Women - Large": 2400,
  "Black Embellished Cropped Button-Up Shirt for Women - Small": 1800,
  "Black Embellished Cropped Button-Up Shirt for Women - Medium": 1800,
  "Black Embellished Cropped Button-Up Shirt for Women - Large": 1800,
  "Classic White Embellished Collar Shirt with Beige Trousers for Women - Small": 1800,
  "Classic White Embellished Collar Shirt with Beige Trousers for Women - Medium": 1800,
  "Classic White Embellished Collar Shirt with Beige Trousers for Women - Large": 1800,
  "Abstract Black & Beige Print Button-Up Shirt for Women - Small": 1800,
  "Abstract Black & Beige Print Button-Up Shirt for Women - Medium": 1800,
  "Abstract Black & Beige Print Button-Up Shirt for Women - Large": 1800,
  "Hot Pink Sleeveless Collared Blouse for Women - Small": 2000,
  "Hot Pink Sleeveless Collared Blouse for Women - Medium": 2000,
  "Hot Pink Sleeveless Collared Blouse for Women - Large": 2000,
  "Olive Green Short Sleeve Button-Up Shirt for Women - Small": 1700,
  "Olive Green Short Sleeve Button-Up Shirt for Women - Medium": 1700,
  "Olive Green Short Sleeve Button-Up Shirt for Women - Large": 1700,
  "Olive Green & Cream Abstract Print Button-Up Shirt for Women - Small": 2300,
  "Olive Green & Cream Abstract Print Button-Up Shirt for Women - Medium": 2300,
  "Olive Green & Cream Abstract Print Button-Up Shirt for Women - Large": 2300,
  "Black & Rose Floral Sheer Button-Up Shirt for Women - Small": 2300,
  "Black & Rose Floral Sheer Button-Up Shirt for Women - Medium": 2300,
  "Black & Rose Floral Sheer Button-Up Shirt for Women - Large": 2300,
  "White Eyelet-Embroidered Short Sleeve Button-Up Shirt for Women - Small": 1500,
  "White Eyelet-Embroidered Short Sleeve Button-Up Shirt for Women - Medium": 1500,
  "White Eyelet-Embroidered Short Sleeve Button-Up Shirt for Women - Large": 1500,
  "White Embellished Collar Button-Up Shirt for Women - Small": 3000,
  "White Embellished Collar Button-Up Shirt for Women - Medium": 3000,
  "White Embellished Collar Button-Up Shirt for Women - Large": 3000,
  "Lavender Short Sleeve Collared Button-Up Shirt for Women - Small": 2400,
  "Lavender Short Sleeve Collared Button-Up Shirt for Women - Medium": 2400,
  "Lavender Short Sleeve Collared Button-Up Shirt for Women - Large": 2400,
  "Lavender Short Sleeve Collared Button-Up Shirt for Women (Copy) - Small": 2400,
  "Lavender Short Sleeve Collared Button-Up Shirt for Women (Copy) - Medium": 2400,
  "Lavender Short Sleeve Collared Button-Up Shirt for Women (Copy) - Large": 2400,
  "Black Embroidered Short Sleeve Flowy Gown for Women - Small": 1300,
  "Black Embroidered Short Sleeve Flowy Gown for Women - Medium": 1300,
  "Black Embroidered Short Sleeve Flowy Gown for Women - Large": 1300,
  "Beige Textured Long Sleeve A-Line Gown for Women - Small": 2800,
  "Beige Textured Long Sleeve A-Line Gown for Women - Medium": 2800,
  "Beige Textured Long Sleeve A-Line Gown for Women - Large": 2800,
  "Black Abstract Mesh A-Line Gown for Women - Small": 2500,
  "Black Abstract Mesh A-Line Gown for Women - Medium": 2500,
  "Black Abstract Mesh A-Line Gown for Women - Large": 2500,
  "Olive Green Tiered Maxi Gown for Women - Small": 2500,
  "Olive Green Tiered Maxi Gown for Women - Medium": 2500,
  "Olive Green Tiered Maxi Gown for Women - Large": 2500,
  "Black Double-Slit Bodycon Evening Gown for Women - Small": 4000,
  "Black Double-Slit Bodycon Evening Gown for Women - Medium": 4000,
  "Black Double-Slit Bodycon Evening Gown for Women - Large": 4000,
  "Black and Stone Abstract Print Mesh Gown for Women - Small": 4000,
  "Black and Stone Abstract Print Mesh Gown for Women - Medium": 4000,
  "Black and Stone Abstract Print Mesh Gown for Women - Large": 4000,
  "Black and Stone Abstract Print Mesh Gown for Women (Copy) - Small": 4000,
  "Black and Stone Abstract Print Mesh Gown for Women (Copy) - Medium": 4000,
  "Black and Stone Abstract Print Mesh Gown for Women (Copy) - Large": 4000,
  "Black & Beige Abstract Print Puff Sleeve Gown for Women - Small": 4000,
  "Black & Beige Abstract Print Puff Sleeve Gown for Women - Medium": 4000,
  "Black & Beige Abstract Print Puff Sleeve Gown for Women - Large": 4000,
  "Leopard Print High-Waisted Wide-Leg Jeans for Women - 24": 2500,
  "Leopard Print High-Waisted Wide-Leg Jeans for Women - 26": 2500,
  "Leopard Print High-Waisted Wide-Leg Jeans for Women - 28": 2500,
  "Classic Indigo High-Waisted Skinny Jeans for Women - 24": 2600,
  "Classic Indigo High-Waisted Skinny Jeans for Women - 26": 2600,
  "Classic Indigo High-Waisted Skinny Jeans for Women - 28": 2600,
  "Classic Indigo Straight-Leg High-Waisted Jeans for Women - 24": 2200,
  "Classic Indigo Straight-Leg High-Waisted Jeans for Women - 26": 2200,
  "Classic Indigo Straight-Leg High-Waisted Jeans for Women - 28": 2200,
  "Black High-Rise Skinny Jeans for Women - 24": 3000,
  "Black High-Rise Skinny Jeans for Women - 26": 3000,
  "Black High-Rise Skinny Jeans for Women - 28": 3000,
  "Jet Black High-Ankle Stretch Skinny Jeans for Women - 24": 3000,
  "Jet Black High-Ankle Stretch Skinny Jeans for Women - 26": 3000,
  "Jet Black High-Ankle Stretch Skinny Jeans for Women - 28": 3000,
  "Jet Black Ultra-Skinny Ankle Jeans for Women - 24": 3000,
  "Jet Black Ultra-Skinny Ankle Jeans for Women - 26": 3000,
  "Jet Black Ultra-Skinny Ankle Jeans for Women - 28": 3000,
  "Deep Indigo High-Waisted Skinny Jeans for Women - 24": 2100,
  "Deep Indigo High-Waisted Skinny Jeans for Women - 26": 2100,
  "Deep Indigo High-Waisted Skinny Jeans for Women - 28": 2100,
  "Classic Indigo High-Waisted Bootcut Jeans for Women - 24": 3000,
  "Classic Indigo High-Waisted Bootcut Jeans for Women - 26": 3000,
  "Classic Indigo High-Waisted Bootcut Jeans for Women - 28": 3000,
  "Classic Mid-Wash Wide-Leg Jeans for Women - 24": 2800,
  "Classic Mid-Wash Wide-Leg Jeans for Women - 26": 2800,
  "Classic Mid-Wash Wide-Leg Jeans for Women - 28": 2800,
  "Classic Mid-Wash Wide-Leg Jeans for Women (Copy) - 24": 2800,
  "Classic Mid-Wash Wide-Leg Jeans for Women (Copy) - 26": 2800,
  "Classic Mid-Wash Wide-Leg Jeans for Women (Copy) - 28": 2800,
  "Washed Indigo Wide-Leg Cargo Jeans for Women - 24": 2800,
  "Washed Indigo Wide-Leg Cargo Jeans for Women - 26": 2800,
  "Washed Indigo Wide-Leg Cargo Jeans for Women - 28": 2800,
  "Jet Black High-Waisted Stretch Skinny Jeans for Women - 24": 3400,
  "Jet Black High-Waisted Stretch Skinny Jeans for Women - 26": 3400,
  "Jet Black High-Waisted Stretch Skinny Jeans for Women - 28": 3400,
  "Light Blue High-Rise Skinny Jeans for Women - 24": 2600,
  "Light Blue High-Rise Skinny Jeans for Women - 26": 2600,
  "Light Blue High-Rise Skinny Jeans for Women - 28": 2600,
  "Jet Black Ankle-Length Super Skinny Jeans for Women - 24": 3000,
  "Jet Black Ankle-Length Super Skinny Jeans for Women - 26": 3000,
  "Jet Black Ankle-Length Super Skinny Jeans for Women - 28": 3000,
  "Black Glitter Wide-Leg Party Jeans for Women - 24": 2800,
  "Black Glitter Wide-Leg Party Jeans for Women - 26": 2800,
  "Black Glitter Wide-Leg Party Jeans for Women - 28": 2800,
  "Matte Black High-Rise Skinny Jeans for Women - 24": 2700,
  "Matte Black High-Rise Skinny Jeans for Women - 26": 2700,
  "Matte Black High-Rise Skinny Jeans for Women - 28": 2700,
  "Vintage Grey High-Rise Wide-Leg Jeans for Women - 24": 2900,
  "Vintage Grey High-Rise Wide-Leg Jeans for Women - 26": 2900,
  "Vintage Grey High-Rise Wide-Leg Jeans for Women - 28": 2900,
  "Dark Blue Button-Fly High-Waisted Skinny Jeans for Women - 24": 2100,
  "Dark Blue Button-Fly High-Waisted Skinny Jeans for Women - 26": 2100,
  "Dark Blue Button-Fly High-Waisted Skinny Jeans for Women - 28": 2100,
  "Classic Blue Mid-Wash Straight-Leg Jeans for Women - 24": 2500,
  "Classic Blue Mid-Wash Straight-Leg Jeans for Women - 26": 2500,
  "Classic Blue Mid-Wash Straight-Leg Jeans for Women - 28": 2500,
  "Stone Grey High-Rise Skinny Jeans for Women - 24": 2000,
  "Stone Grey High-Rise Skinny Jeans for Women - 26": 2000,
  "Stone Grey High-Rise Skinny Jeans for Women - 28": 2000,
  "Light Blue Distressed High-Rise Skinny Jeans for Women - 24": 2000,
  "Light Blue Distressed High-Rise Skinny Jeans for Women - 26": 2000,
  "Light Blue Distressed High-Rise Skinny Jeans for Women - 28": 2000,
  "Navy & White Striped Women's Shorts - 24": 1000,
  "Navy & White Striped Women's Shorts - 26": 1000,
  "Navy & White Striped Women's Shorts - 28": 1000,
  "Women's Beige Belted Bermuda Shorts - 24": 1000,
  "Women's Beige Belted Bermuda Shorts - 26": 1000,
  "Women's Beige Belted Bermuda Shorts - 28": 1000,
  "Women's Red & Cream Floral Print Romper - 24": 800,
  "Women's Red & Cream Floral Print Romper - 26": 800,
  "Women's Red & Cream Floral Print Romper - 28": 800,
  "Women's Tropical Print Pajama Set - 24": 800,
  "Women's Tropical Print Pajama Set - 26": 800,
  "Women's Tropical Print Pajama Set - 28": 800,
  "Women's White High-Waisted Denim Shorts - 24": 1800,
  "Women's White High-Waisted Denim Shorts - 26": 1800,
  "Women's White High-Waisted Denim Shorts - 28": 1800,
  "Women's Light Wash Denim Bermuda Shorts - 24": 1600,
  "Women's Light Wash Denim Bermuda Shorts - 26": 1600,
  "Women's Light Wash Denim Bermuda Shorts - 28": 1600,
  "Women's Blue Tropical Hibiscus Print Shorts - 24": 1200,
  "Women's Blue Tropical Hibiscus Print Shorts - 26": 1200,
  "Women's Blue Tropical Hibiscus Print Shorts - 28": 1200,
  "Women's Neon Pink & Yellow Athletic Shorts - 24": 900,
  "Women's Neon Pink & Yellow Athletic Shorts - 26": 900,
  "Women's Neon Pink & Yellow Athletic Shorts - 28": 900,
  "Women's Camouflage Cargo Bermuda Shorts - 24": 2500,
  "Women's Camouflage Cargo Bermuda Shorts - 26": 2500,
  "Women's Camouflage Cargo Bermuda Shorts - 28": 2500,
  "Women's Khaki Cropped Chino Pants - 24": 2000,
  "Women's Khaki Cropped Chino Pants - 26": 2000,
  "Women's Khaki Cropped Chino Pants - 28": 2000,
  "Women's Crystal Trim Cut-Out Denim Shorts - 24": 1100,
  "Women's Crystal Trim Cut-Out Denim Shorts - 26": 1100,
  "Women's Crystal Trim Cut-Out Denim Shorts - 28": 1100,
  "Women's White Cherry Print Pajama Shorts - 24": 600,
  "Women's White Cherry Print Pajama Shorts - 26": 600,
  "Women's White Cherry Print Pajama Shorts - 28": 600,
  "Women's Fruit Print Cord Set (Shirt & Shorts) - 24": 1700,
  "Women's Fruit Print Cord Set (Shirt & Shorts) - 26": 1700,
  "Women's Fruit Print Cord Set (Shirt & Shorts) - 28": 1700,
  "Women's Black & White Abstract Print Bermuda Shorts - 24": 1100,
  "Women's Black & White Abstract Print Bermuda Shorts - 26": 1100,
  "Women's Black & White Abstract Print Bermuda Shorts - 28": 1100,
  "Women's Olive Green Bermuda Shorts with Tan Belt - 24": 2500,
  "Women's Olive Green Bermuda Shorts with Tan Belt - 26": 2500,
  "Women's Olive Green Bermuda Shorts with Tan Belt - 28": 2500,
  "Women's Green Leaf Print Relaxed Shorts - 24": 800,
  "Women's Green Leaf Print Relaxed Shorts - 26": 800,
  "Women's Green Leaf Print Relaxed Shorts - 28": 800,
  "Women's Dark Blue Utility Wrap Denim Skirt - 24": 1800,
  "Women's Dark Blue Utility Wrap Denim Skirt - 26": 1800,
  "Women's Dark Blue Utility Wrap Denim Skirt - 28": 1800,
  "Women's Pink Butterfly Print Pajama Shorts - 24": 900,
  "Women's Pink Butterfly Print Pajama Shorts - 26": 900,
  "Women's Pink Butterfly Print Pajama Shorts - 28": 900,
  "Women's Black Cotton Relaxed Shorts - 24": 1300,
  "Women's Black Cotton Relaxed Shorts - 26": 1300,
  "Women's Black Cotton Relaxed Shorts - 28": 1300,
  "Women's Dark Blue Stretch Denim Capri Pants - 24": 1800,
  "Women's Dark Blue Stretch Denim Capri Pants - 26": 1800,
  "Women's Dark Blue Stretch Denim Capri Pants - 28": 1800,
  "Women's Red Relaxed Lounge Cord Set (Top & Shorts) - 24": 2000,
  "Women's Red Relaxed Lounge Cord Set (Top & Shorts) - 26": 2000,
  "Women's Red Relaxed Lounge Cord Set (Top & Shorts) - 28": 2000,
  "Women's Beige Cargo Bermuda Shorts - 24": 2000,
  "Women's Beige Cargo Bermuda Shorts - 26": 2000,
  "Women's Beige Cargo Bermuda Shorts - 28": 2000,
  "Women's Taupe & White Abstract Print Cord Set (Shirt & Shorts) - 24": 2000,
  "Women's Taupe & White Abstract Print Cord Set (Shirt & Shorts) - 26": 2000,
  "Women's Taupe & White Abstract Print Cord Set (Shirt & Shorts) - 28": 2000,
  "Women's Olive Green Palm Print Cord Set (Top & Shorts) - 24": 2000,
  "Women's Olive Green Palm Print Cord Set (Top & Shorts) - 26": 2000,
  "Women's Olive Green Palm Print Cord Set (Top & Shorts) - 28": 2000,
  "Women's Beige Cotton Relaxed Shorts - 24": 1400,
  "Women's Beige Cotton Relaxed Shorts - 26": 1400,
  "Women's Beige Cotton Relaxed Shorts - 28": 1400,
  "Women's Brown Utility Mini Skirt - 24": 1700,
  "Women's Brown Utility Mini Skirt - 26": 1700,
  "Women's Brown Utility Mini Skirt - 28": 1700,
  "Women's Black Sheer Lace Maxi Skirt - 24": 2500,
  "Women's Black Sheer Lace Maxi Skirt - 26": 2500,
  "Women's Black Sheer Lace Maxi Skirt - 28": 2500,
  "Women's Abstract Multi-Color Pleated Midi Skirt - 24": 2500,
  "Women's Abstract Multi-Color Pleated Midi Skirt - 26": 2500,
  "Women's Abstract Multi-Color Pleated Midi Skirt - 28": 2500,
  "Women's Bright Red Maxi Skirt - 24": 1800,
  "Women's Bright Red Maxi Skirt - 26": 1800,
  "Women's Bright Red Maxi Skirt - 28": 1800,
  "Ribbed Striped Knit Maxi Skirt - 24": 2200,
  "Ribbed Striped Knit Maxi Skirt - 26": 2200,
  "Ribbed Striped Knit Maxi Skirt - 28": 2200,
  "Leopard Print Midi Skirt - 24": 2800,
  "Leopard Print Midi Skirt - 26": 2800,
  "Leopard Print Midi Skirt - 28": 2800,
  "Tiered Maxi Skirt with Sleeveless Top - 24": 1700,
  "Tiered Maxi Skirt with Sleeveless Top - 26": 1700,
  "Tiered Maxi Skirt with Sleeveless Top - 28": 1700,
  "Olive Belted High-Waist Maxi Skirt - 24": 2200,
  "Olive Belted High-Waist Maxi Skirt - 26": 2200,
  "Olive Belted High-Waist Maxi Skirt - 28": 2200,
  "Geometric Patterned Pencil Skirt - 24": 2400,
  "Geometric Patterned Pencil Skirt - 26": 2400,
  "Geometric Patterned Pencil Skirt - 28": 2400,
  "Brown High-Waist Pencil Skirt - 24": 2500,
  "Brown High-Waist Pencil Skirt - 26": 2500,
  "Brown High-Waist Pencil Skirt - 28": 2500,
  "White Bubble Hem Mini Skirt - 24": 1400,
  "White Bubble Hem Mini Skirt - 26": 1400,
  "White Bubble Hem Mini Skirt - 28": 1400,
  "Light Blue Denim Mini Skort - 24": 1400,
  "Light Blue Denim Mini Skort - 26": 1400,
  "Light Blue Denim Mini Skort - 28": 1400,
  "Dark Blue Denim A-Line Maxi Skirt - 24": 3000,
  "Dark Blue Denim A-Line Maxi Skirt - 26": 3000,
  "Dark Blue Denim A-Line Maxi Skirt - 28": 3000,
  "Blue Denim Pencil Skirt with Elastic Waist - 24": 1900,
  "Blue Denim Pencil Skirt with Elastic Waist - 26": 1900,
  "Blue Denim Pencil Skirt with Elastic Waist - 28": 1900,
  "Beige Pleated Maxi Skirt - 24": 2800,
  "Beige Pleated Maxi Skirt - 26": 2800,
  "Beige Pleated Maxi Skirt - 28": 2800,
  "Abstract Print Pleated Midi Skirt - 24": 1500,
  "Abstract Print Pleated Midi Skirt - 26": 1500,
  "Abstract Print Pleated Midi Skirt - 28": 1500,
  "Rose Pleated Maxi Skirt - 24": 1500,
  "Rose Pleated Maxi Skirt - 26": 1500,
  "Rose Pleated Maxi Skirt - 28": 1500,
  "Black & Beige Abstract Floral Pleated Midi Skirt - 24": 1400,
  "Black & Beige Abstract Floral Pleated Midi Skirt - 26": 1400,
  "Black & Beige Abstract Floral Pleated Midi Skirt - 28": 1400,
  "Black Pleated Midi Skirt - 24": 2500,
  "Black Pleated Midi Skirt - 26": 2500,
  "Black Pleated Midi Skirt - 28": 2500,
  "Multicolor Abstract Print Pleated Midi Skirt - 24": 2000,
  "Multicolor Abstract Print Pleated Midi Skirt - 26": 2000,
  "Multicolor Abstract Print Pleated Midi Skirt - 28": 2000,
  "Black & White Houndstooth Pencil Skirt - 24": 2000,
  "Black & White Houndstooth Pencil Skirt - 26": 2000,
  "Black & White Houndstooth Pencil Skirt - 28": 2000,
  "White Leaf Print Short Sleeve Blouse - Small": 1200,
  "White Leaf Print Short Sleeve Blouse - Medium": 1200,
  "White Leaf Print Short Sleeve Blouse - Large": 1200,
  "Red & White Watercolor Print Wrap Top - Small": 1800,
  "Red & White Watercolor Print Wrap Top - Medium": 1800,
  "Red & White Watercolor Print Wrap Top - Large": 1800,
  "White Fitted T-Shirt with Subtle All-Over Print - Small": 900,
  "White Fitted T-Shirt with Subtle All-Over Print - Medium": 900,
  "White Fitted T-Shirt with Subtle All-Over Print - Large": 900,
  "Khaki & White Stripe Cotton T-Shirt - Small": 800,
  "Khaki & White Stripe Cotton T-Shirt - Medium": 800,
  "Khaki & White Stripe Cotton T-Shirt - Large": 800,
  "Ivory Knit Polo Top with Black Contrast Trim - Small": 700,
  "Ivory Knit Polo Top with Black Contrast Trim - Medium": 700,
  "Ivory Knit Polo Top with Black Contrast Trim - Large": 700,
  "Teal Leaf Motif Short Sleeve Blouse - Small": 1500,
  "Teal Leaf Motif Short Sleeve Blouse - Medium": 1500,
  "Teal Leaf Motif Short Sleeve Blouse - Large": 1500,
  "Black Basic Cotton T-Shirt - Small": 800,
  "Black Basic Cotton T-Shirt - Medium": 800,
  "Black Basic Cotton T-Shirt - Large": 800,
  "Pale Pink Rolled Sleeve Cotton T-Shirt - Small": 400,
  "Pale Pink Rolled Sleeve Cotton T-Shirt - Medium": 400,
  "Pale Pink Rolled Sleeve Cotton T-Shirt - Large": 400,
  "Brown Pocket Short Sleeve T-Shirt - Small": 700,
  "Brown Pocket Short Sleeve T-Shirt - Medium": 700,
  "Brown Pocket Short Sleeve T-Shirt - Large": 700,
  "Navy Blue Graphic Face T-Shirt - Small": 700,
  "Navy Blue Graphic Face T-Shirt - Medium": 700,
  "Navy Blue Graphic Face T-Shirt - Large": 700,
  "Sage Green V-Neck Relaxed Cotton T-Shirt - Small": 300,
  "Sage Green V-Neck Relaxed Cotton T-Shirt - Medium": 300,
  "Sage Green V-Neck Relaxed Cotton T-Shirt - Large": 300,
  "Red Sweetheart Neckline Fitted Crop Top - Small": 1400,
  "Red Sweetheart Neckline Fitted Crop Top - Medium": 1400,
  "Red Sweetheart Neckline Fitted Crop Top - Large": 1400,
  "Multicolor Floral Print Wrap Blouse - Small": 1600,
  "Multicolor Floral Print Wrap Blouse - Medium": 1600,
  "Multicolor Floral Print Wrap Blouse - Large": 1600,
  "Black Mesh Embellished Long Sleeve Top - Small": 2500,
  "Black Mesh Embellished Long Sleeve Top - Medium": 2500,
  "Black Mesh Embellished Long Sleeve Top - Large": 2500,
  "White Polka Dot Puff Sleeve Buttoned Blouse - Small": 1000,
  "White Polka Dot Puff Sleeve Buttoned Blouse - Medium": 1000,
  "White Polka Dot Puff Sleeve Buttoned Blouse - Large": 1000,
  "Light Blue Sleeveless Pintuck Cotton Top - Small": 1300,
  "Light Blue Sleeveless Pintuck Cotton Top - Medium": 1300,
  "Light Blue Sleeveless Pintuck Cotton Top - Large": 1300,
  "Light Blue Sleeveless Pintuck Cotton Top (Copy) - Small": 1300,
  "Light Blue Sleeveless Pintuck Cotton Top (Copy) - Medium": 1300,
  "Light Blue Sleeveless Pintuck Cotton Top (Copy) - Large": 1300,
  "Beige Wide-Leg Pleated Trousers - 24": 2000,
  "Beige Wide-Leg Pleated Trousers - 26": 2000,
  "Beige Wide-Leg Pleated Trousers - 28": 2000,
  "Brown High-Rise Tapered Tailored Trouser for Women - 24": 1800,
  "Brown High-Rise Tapered Tailored Trouser for Women - 26": 1800,
  "Brown High-Rise Tapered Tailored Trouser for Women - 28": 1800,
  "Mustard Yellow High-Rise Wide-Leg Trouser for Women - 24": 2000,
  "Mustard Yellow High-Rise Wide-Leg Trouser for Women - 26": 2000,
  "Mustard Yellow High-Rise Wide-Leg Trouser for Women - 28": 2000,
  "Beige High-Rise Wide-Leg Trouser for Women - 24": 2500,
  "Beige High-Rise Wide-Leg Trouser for Women - 26": 2500,
  "Beige High-Rise Wide-Leg Trouser for Women - 28": 2500,
  "Olive Green High-Rise Wide-Leg Trouser for Women - 24": 1900,
  "Olive Green High-Rise Wide-Leg Trouser for Women - 26": 1900,
  "Olive Green High-Rise Wide-Leg Trouser for Women - 28": 1900,
  "Multicolor Abstract Print Pleated Trouser for Women - 24": 1900,
  "Multicolor Abstract Print Pleated Trouser for Women - 26": 1900,
  "Multicolor Abstract Print Pleated Trouser for Women - 28": 1900,
  "Camel Brown High-Rise Wide-Leg Trouser for Women - 24": 1900,
  "Camel Brown High-Rise Wide-Leg Trouser for Women - 26": 1900,
  "Camel Brown High-Rise Wide-Leg Trouser for Women - 28": 1900,
  "Beige High-Rise Tapered Trouser for Women - 24": 2500,
  "Beige High-Rise Tapered Trouser for Women - 26": 2500,
  "Beige High-Rise Tapered Trouser for Women - 28": 2500,
  "Brown Plaid Wide-Leg Drawstring Trouser for Women - 24": 1600,
  "Brown Plaid Wide-Leg Drawstring Trouser for Women - 26": 1600,
  "Brown Plaid Wide-Leg Drawstring Trouser for Women - 28": 1600,
  "Rust Brown High-Rise Straight-Leg Trouser for Women - 24": 2500,
  "Rust Brown High-Rise Straight-Leg Trouser for Women - 26": 2500,
  "Rust Brown High-Rise Straight-Leg Trouser for Women - 28": 2500,
  "Wine Brown High-Rise Wide-Leg Trouser for Women - 24": 2500,
  "Wine Brown High-Rise Wide-Leg Trouser for Women - 26": 2500,
  "Wine Brown High-Rise Wide-Leg Trouser for Women - 28": 2500,
  "Light Grey Drawstring Straight-Leg Jogger Trouser for Women - 24": 800,
  "Light Grey Drawstring Straight-Leg Jogger Trouser for Women - 26": 800,
  "Light Grey Drawstring Straight-Leg Jogger Trouser for Women - 28": 800,
  "Rust Brown High-Rise Wide-Leg Trouser for Women - 24": 2000,
  "Rust Brown High-Rise Wide-Leg Trouser for Women - 26": 2000,
  "Rust Brown High-Rise Wide-Leg Trouser for Women - 28": 2000,
  "Black High-Rise Tapered Trouser for Women - 24": 2000,
  "Black High-Rise Tapered Trouser for Women - 26": 2000,
  "Black High-Rise Tapered Trouser for Women - 28": 2000,
  "Wine Red High-Rise Tapered Trouser for Women - 24": 2200,
  "Wine Red High-Rise Tapered Trouser for Women - 26": 2200,
  "Wine Red High-Rise Tapered Trouser for Women - 28": 2200,
  "Chocolate Brown High-Rise Tapered Trouser for Women - 24": 2200,
  "Chocolate Brown High-Rise Tapered Trouser for Women - 26": 2200,
  "Chocolate Brown High-Rise Tapered Trouser for Women - 28": 2200,
  "Terracotta Brown High-Rise Straight-Leg Trouser for Women - 24": 2200,
  "Terracotta Brown High-Rise Straight-Leg Trouser for Women - 26": 2200,
  "Terracotta Brown High-Rise Straight-Leg Trouser for Women - 28": 2200,
  "Terracotta Brown High-Rise Straight-Leg Trouser for Women (Copy) - 24": 2200,
  "Terracotta Brown High-Rise Straight-Leg Trouser for Women (Copy) - 26": 2200,
  "Terracotta Brown High-Rise Straight-Leg Trouser for Women (Copy) - 28": 2200,
  "Olive Brown High-Rise Tapered Trouser for Women - 24": 2200,
  "Olive Brown High-Rise Tapered Trouser for Women - 26": 2200,
  "Olive Brown High-Rise Tapered Trouser for Women - 28": 2200,
  "Taupe Brown High-Rise Wide-Leg Trouser for Women - 24": 2200,
  "Taupe Brown High-Rise Wide-Leg Trouser for Women - 26": 2200,
  "Taupe Brown High-Rise Wide-Leg Trouser for Women - 28": 2200,
  "Ivory Satin Button-Front Shirt for Women - Small": 1500,
  "Ivory Satin Button-Front Shirt for Women - Medium": 1500,
  "Ivory Satin Button-Front Shirt for Women - Large": 1500,
  "Blue Satin Button-Front Tie-Waist Shirt for Women - Small": 1500,
  "Blue Satin Button-Front Tie-Waist Shirt for Women - Medium": 1500,
  "Blue Satin Button-Front Tie-Waist Shirt for Women - Large": 1500,
  "Black & White Geometric Print Button-Front Shirt for Women - Small": 1500,
  "Black & White Geometric Print Button-Front Shirt for Women - Medium": 1500,
  "Black & White Geometric Print Button-Front Shirt for Women - Large": 1500,
  "Blue Denim Button-Front Shirt for Women - Small": 1500,
  "Blue Denim Button-Front Shirt for Women - Medium": 1500,
  "Blue Denim Button-Front Shirt for Women - Large": 1500,
  "White Floral Print Button-Front Shirt for Women - Small": 1400,
  "White Floral Print Button-Front Shirt for Women - Medium": 1400,
  "White Floral Print Button-Front Shirt for Women - Large": 1400,
  "White & Blue Vertical Stripe Button-Front Shirt for Women - Small": 1000,
  "White & Blue Vertical Stripe Button-Front Shirt for Women - Medium": 1000,
  "White & Blue Vertical Stripe Button-Front Shirt for Women - Large": 1000,
  "Blue & White Ornate Geometric Print Short-Sleeve Shirt for Women - Small": 800,
  "Blue & White Ornate Geometric Print Short-Sleeve Shirt for Women - Medium": 800,
  "Blue & White Ornate Geometric Print Short-Sleeve Shirt for Women - Large": 800,
  "Blue & Ivory Abstract Print Button-Front Shirt for Women - Small": 800,
  "Blue & Ivory Abstract Print Button-Front Shirt for Women - Medium": 800,
  "Blue & Ivory Abstract Print Button-Front Shirt for Women - Large": 800,
  "Black One-Shoulder Embellished Evening Gown for Women - Small": 10000,
  "Black One-Shoulder Embellished Evening Gown for Women - Medium": 10000,
  "Black One-Shoulder Embellished Evening Gown for Women - Large": 10000,
  "Navy Satin Sleeveless Draped Midi Gown for Women - Small": 10000,
  "Navy Satin Sleeveless Draped Midi Gown for Women - Medium": 10000,
  "Navy Satin Sleeveless Draped Midi Gown for Women - Large": 10000,
  "Emerald Green Satin Corset-Bodice Gown for Women - Small": 10000,
  "Emerald Green Satin Corset-Bodice Gown for Women - Medium": 10000,
  "Emerald Green Satin Corset-Bodice Gown for Women - Large": 10000,
  "Wine Red Satin Lace-Bodice Gown for Women - Small": 10000,
  "Wine Red Satin Lace-Bodice Gown for Women - Medium": 10000,
  "Wine Red Satin Lace-Bodice Gown for Women - Large": 10000,
  "Wine Red Satin Lace-Bodice Gown for Women (Copy) - Small": 10000,
  "Wine Red Satin Lace-Bodice Gown for Women (Copy) - Medium": 10000,
  "Wine Red Satin Lace-Bodice Gown for Women (Copy) - Large": 10000,
  "Emerald Green Satin Draped Midi Dress for Women - Small": 10000,
  "Emerald Green Satin Draped Midi Dress for Women - Medium": 10000,
  "Emerald Green Satin Draped Midi Dress for Women - Large": 10000,
  "Bronze Metallic Pleated Cut-Out Evening Gown for Women - Small": 2000,
  "Bronze Metallic Pleated Cut-Out Evening Gown for Women - Medium": 2000,
  "Bronze Metallic Pleated Cut-Out Evening Gown for Women - Large": 2000,
  "Teal One-Shoulder Draped Dress for Women - Small": 2000,
  "Teal One-Shoulder Draped Dress for Women - Medium": 2000,
  "Teal One-Shoulder Draped Dress for Women - Large": 2000,
  "Black Keyhole-Front Embellished Halter Gown for Women - Small": 2000,
  "Black Keyhole-Front Embellished Halter Gown for Women - Medium": 2000,
  "Black Keyhole-Front Embellished Halter Gown for Women - Large": 2000,
  "Green Sequin Long Sleeve Slit Gown for Women - Small": 2000,
  "Green Sequin Long Sleeve Slit Gown for Women - Medium": 2000,
  "Green Sequin Long Sleeve Slit Gown for Women - Large": 2000,
  "Rose Gold Sequin One-Shoulder Gown for Women - Small": 2000,
  "Rose Gold Sequin One-Shoulder Gown for Women - Medium": 2000,
  "Rose Gold Sequin One-Shoulder Gown for Women - Large": 2000,
  "Midnight Navy Metallic Drape-Back Gown for Women - Small": 2000,
  "Midnight Navy Metallic Drape-Back Gown for Women - Medium": 2000,
  "Midnight Navy Metallic Drape-Back Gown for Women - Large": 2000,
};

const findCombinations = (
  targetAmount,
  currentProducts = {},
  currentSum = 0,
  combinations = [],
  limit = 10
) => {
  const productNames = Object.keys(products);
  const productPrices = Object.values(products);

  if (currentSum >= targetAmount && currentSum <= targetAmount + 100) {
    const combinationResult = {
      balance: currentSum - targetAmount,
      products: {},
    };

    for (const [name, details] of Object.entries(currentProducts)) {
      combinationResult.products[name] = {
        quantity: details.quantity,
        price: details.price,
      };
    }

    combinations.push(combinationResult);

    if (combinations.length >= limit) {
      return combinations;
    }
  }

  if (currentSum > targetAmount + 100) {
    return combinations;
  }

  for (let i = 0; i < productNames.length; i++) {
    const productName = productNames[i];
    const productPrice = productPrices[i];

    if (!currentProducts[productName]) {
      currentProducts[productName] = { quantity: 0, price: productPrice };
    }

    if (currentProducts[productName].quantity >= 5) {
      continue;
    }

    currentProducts[productName].quantity++;

    combinations = findCombinations(
      targetAmount,
      currentProducts,
      currentSum + productPrice,
      combinations,
      limit
    );

    currentProducts[productName].quantity--;

    if (currentProducts[productName].quantity === 0) {
      delete currentProducts[productName];
    }

    if (combinations.length >= limit) break;
  }

  return combinations;
};

export const getProductCombinations = (userInput) => {
  const amount = Number(userInput.split(".")[0]);

  const combinations = findCombinations(amount);

  if (combinations.length === 0)
    throw new Error("No valid combinations found within the specified range.");

  return combinations[combinations.length - 1];
};
